var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5701 59.8458C24.3422 56.018 32.166 53.8333 40.5 53.8333C48.834 53.8333 56.6578 56.018 63.4299 59.8458M50.5 33.8333C50.5 39.3562 46.0228 43.8333 40.5 43.8333C34.9772 43.8333 30.5 39.3562 30.5 33.8333C30.5 28.3105 34.9772 23.8333 40.5 23.8333C46.0228 23.8333 50.5 28.3105 50.5 33.8333ZM70.5 40.5C70.5 57.0685 57.0685 70.5 40.5 70.5C23.9315 70.5 10.5 57.0685 10.5 40.5C10.5 23.9315 23.9315 10.5 40.5 10.5C57.0685 10.5 70.5 23.9315 70.5 40.5Z",
    stroke: "#345658",
    strokeWidth: 6.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnStudent);
export default __webpack_public_path__ + "static/media/Btn_Student.b14eee425d81645688d84e2ec7a7da80.svg";
export { ForwardRef as ReactComponent };